import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTreeGet = {
    path: "/tree",
    method: RouteHttpVerb.GET
};
export { locationRestTreeGet };
